<template>
  <div
    v-if="isCircle"
    class="loader-spinner"
    :class="{
      'loader-spinner--white': isWhite,
      'loader-spinner--absolute': isAbsolute,
    }"
  >
    <svg viewBox="25 25 50 50" class="loader-spinner__item">
      <circle
        cx="50"
        cy="50"
        r="20"
        fill="none"
        stroke="currentColor"
        stroke-width="5"
        stroke-miterlimit="10"
        class="loader-spinner__path"
      ></circle>
    </svg>
  </div>
  <div
    v-else
    class="loader"
    :class="{
      'loader--white': isWhite,
      'loader--absolute': isAbsolute,
    }"
  >
    <div class="loader__circle"></div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    isWhite: {
      type: Boolean,
      default: false,
    },
    isCircle: {
      type: Boolean,
      default: false,
    },
    isAbsolute: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.loader {
  position: relative;
  display: flex;
  align-items: center;
  color: $color-brand-green;

  &::after,
  &::before {
    content: '';
  }

  &__circle,
  &::after,
  &::before {
    display: block;
    flex-shrink: 0;
    width: 8px;
    height: 8px;
    background-color: $current-color;
    border-radius: 50%;
    animation-name: scale;
    animation-duration: 600ms;
    animation-iteration-count: infinite;
  }

  &::before {
    animation-delay: 100ms;
  }

  &__circle {
    margin: 6px;
    animation-delay: 200ms;
  }

  &::after {
    animation-delay: 300ms;
  }

  // --white
  &--white {
    color: $color-white;
  }

  &--absolute {
    position: absolute;
  }
}

.loader-spinner {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $color-brand-green;

  &--white {
    color: $color-white;
  }

  &--absolute {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    background: transparent;
  }

  &__item {
    width: 42px;
    height: 42px;
    transform-origin: 50% 50%;
    animation: spin 2s linear infinite;
  }

  &__path {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    animation: mat-dash 1.5s ease-in-out infinite;
  }
}

@keyframes spin {
  0% {
    transform: rotate3d(0, 0, 1, 0deg);
  }

  25% {
    transform: rotate3d(0, 0, 1, 90deg);
  }

  50% {
    transform: rotate3d(0, 0, 1, 180deg);
  }

  75% {
    transform: rotate3d(0, 0, 1, 270deg);
  }

  100% {
    transform: rotate3d(0, 0, 1, 359deg);
  }
}

@keyframes mat-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }

  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}
</style>
